module.exports = __webpack_public_path__ + "/login_ui/img/nu-6c2313adedb7eb77c19066e01b28e756.svg";